/**
 * @desc 通过FnSku获取Sku
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.PdaFnskuRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/pda/getSkuByFnSku`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
